import waitForLoad from "../utils/waitForLoad";
var domain = 'https://app.chatwoot.com';
/* eslint-disable */
var loadScript = function loadScript(onload, baseUrl) {
  if (window.$chatwoot) return false;
  (function (d, t, _fisrtScript$parentNo) {
    var script = d.createElement('script');
    var fisrtScript = d.getElementsByTagName('script')[0];
    script.src = baseUrl + '/packs/js/sdk.js';
    (_fisrtScript$parentNo = fisrtScript.parentNode) === null || _fisrtScript$parentNo === void 0 || _fisrtScript$parentNo.insertBefore(script, fisrtScript);
    script.onload = onload;
  })(document);
  return true;
};
/* eslint-enable */

var load = function load(_ref) {
  var providerKey = _ref.providerKey,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en' : _ref$locale,
    setState = _ref.setState,
    _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? domain : _ref$baseUrl,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  var loaded = loadScript(function () {
    beforeInit();
    setTimeout(function () {
      setState('complete');
      onReady();
    }, 1000);
    window.chatwootSDK.run({
      websiteToken: providerKey,
      baseUrl: baseUrl,
      locale: locale
    });
  }, baseUrl);

  // Continue as long as userlike hasn’t already been initialised.
  if (loaded) {
    waitForLoad(function () {
      var _window$$chatwoot;
      return !!((_window$$chatwoot = window.$chatwoot) !== null && _window$$chatwoot !== void 0 && _window$$chatwoot.hasLoaded);
    },
    // Allow chatwoot to complete loading before removing fake widget
    function () {
      return setTimeout(function () {
        return setState('complete');
      }, 2000);
    });
  }
};
var open = function open() {
  window.chatwootSettings = window.chatwootSettings || {};
  window.chatwootSettings.showPopoutButton = true;
  window.addEventListener('chatwoot:ready', function () {
    window.$chatwoot.toggle();
  });
};
export default {
  domain: domain,
  load: load,
  open: open
};